<template>
  <NuxtLayout>
    <div class="brandDetail__Content">
      <section class="brandDetail__Header">
        <h1 v-text="page.title" />
        <div class="videoHeader__Player" v-if="page.video_url">
          <video :src="page.video_url" poster="/resources/images/video-poster.jpg" autoplay muted loop playsinline data-not-lazy></video>
        </div>
        <FlarePicture v-else :src="{
            1920: { src: page.image, width: 1920, height: 960, size: 'both', crop: 'fill', requestLarger: false },
            1440: { src: page.image, width: 1440, height: 720, size: 'both', crop: 'fill', requestLarger: false },
            1024: { src: page.image_mobile || page.image, width: page.image_mobile ? 750 : 1024, height: page.image_mobile ? 1050 : 512, size: 'both', crop: 'fill', requestLarger: false }
          }"
          class="brandDetails__HeaderMainImage"
          :alt="page.image?.alt"
          :lazy="false"
          fetchPriority="high"
        />
        <Flare v-if="page.logo" class="brandDetails__HeaderLogo" :srcset="page.logo" width="380" :alt="page.logo" :lazy="false" fetchPriority="high" />
      </section>

      <CMSField v-if="page?.content" :data="page.content" />
    </div>
  </NuxtLayout>
</template>

<script setup>
  defineOptions({
    auth: 'aminess'
  });
  
  const props = defineProps({
    page: {}
  });

  useHead({
    bodyAttrs: {
      class: 'transparentHeader brandDetail'
    },
    link: [
      {
        rel: 'preload',
        as: 'image',
        fetchpriority: 'high',
        href: '/resources/images/video-poster.jpg',
      },
    ],
  })

  const isMobile = ref(false);
  const videoId = computed(() => isMobile.value ? props.page.video_mobile_url : props.page.video_url);

  onMounted(() => {
    if (window?.innerWidth < 768) isMobile.value = true;
  });
</script>

<style lang="scss">
  @import url('@/assets/styles/pages/_brandDetail.scss');
</style>